import { useCallback, useEffect, useState } from "react";
import * as approvalsApi from "@/lib/approvalsApi";

const REFRESH_MS = 60000;

/**
 * How many AI-staged requests wait for a decision: the badge beside Approvals. Only runs for
 * a person who holds the switch (the endpoint refuses everyone else). A failed count shows no
 * badge rather than a wrong one; the screen itself names a failure.
 */
export function usePendingApprovals(token, enabled) {
  const [count, setCount] = useState(0);
  const refresh = useCallback(() => {
    if (!enabled || !token) return;
    approvalsApi.countPending(token).then(setCount).catch(() => setCount(0));
  }, [enabled, token]);

  useEffect(() => {
    refresh();
    if (!enabled) return undefined;
    const timer = setInterval(refresh, REFRESH_MS);
    window.addEventListener("approvals-changed", refresh);
    return () => {
      clearInterval(timer);
      window.removeEventListener("approvals-changed", refresh);
    };
  }, [enabled, refresh]);

  return count;
}
